module.exports = __webpack_public_path__ + "img/svg/document-check.4c17369e5e83d8d06916f843aa1df7b0.svg";